(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curious-collection-detail"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sortForm = document.querySelector('[data-curious-sort]');
  if (sortForm) {
    sortForm.querySelector('select').addEventListener('change', function(e){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Mobile sidebar toggle
  var sidebar = document.querySelector('[data-curious-sidebar]');
  var sidebarToggle = document.querySelector('[data-curious-sidebar-toggle]');
  if (sidebar && sidebarToggle) {
    sidebarToggle.addEventListener('click', function () {
      var open = sidebar.classList.toggle('is-open');
      sidebarToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Filter checkboxes: navigate using Shopify's url_to_add / url_to_remove
  document.querySelectorAll('[data-curious-filter-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var target = input.checked
        ? input.getAttribute('data-curious-filter-add')
        : input.getAttribute('data-curious-filter-remove');
      if (target) window.location.href = target;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curious-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var header = document.querySelector('.curious-header');
  var btn = document.querySelector('[data-curious-menu-toggle]');
  var menu = document.querySelector('[data-curious-menu]');

  if (btn && menu) {
    btn.addEventListener('click', function(){
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---- Collections dropdown ----
  var collsRoot = document.querySelector('[data-curious-colls]');
  var collsToggle = document.querySelector('[data-curious-colls-toggle]');
  if (collsRoot && collsToggle) {
    collsToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = collsRoot.classList.toggle('is-open');
      collsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!collsRoot.contains(e.target)) {
        collsRoot.classList.remove('is-open');
        collsToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && collsRoot.classList.contains('is-open')) {
        collsRoot.classList.remove('is-open');
        collsToggle.setAttribute('aria-expanded', 'false');
        collsToggle.focus();
      }
    });
  }

  // ---- Predictive search modal ----
  var psModal = document.querySelector('[data-curious-search-modal]');
  var psInput = document.querySelector('[data-curious-search-input]');
  var psResults = document.querySelector('[data-curious-search-results]');
  var psToggle = document.querySelector('[data-curious-search-toggle]');
  var psClose = document.querySelector('[data-curious-search-close]');

  function psOpen() {
    if (!psModal) return;
    psModal.classList.add('is-open');
    psModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('curious-psearch-open');
    setTimeout(function () { if (psInput) psInput.focus(); }, 60);
  }
  function psCloseFn() {
    if (!psModal) return;
    psModal.classList.remove('is-open');
    psModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('curious-psearch-open');
  }

  if (psToggle) psToggle.addEventListener('click', psOpen);
  if (psClose) psClose.addEventListener('click', psCloseFn);
  if (psModal) {
    psModal.addEventListener('click', function (e) {
      if (e.target === psModal) psCloseFn();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && psModal && psModal.classList.contains('is-open')) psCloseFn();
  });

  var psTimer = null;
  if (psInput) {
    psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (!q) { psResults.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        var url = '/search/suggest?q=' + encodeURIComponent(q)
          + '&resources[type]=product'
          + '&resources[limit]=8'
          + '&section_id=curious-predictive-search';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            // Section Rendering returns just the section HTML wrapped in shopify-section
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sect = doc.querySelector('.shopify-section') || doc.body;
            psResults.innerHTML = sect.innerHTML;
          })
          .catch(function (err) { console.warn('[curious-search]', err); });
      }, 250);
    });
  }

  // Hide-on-scroll-down, reveal-on-scroll-up
  if (!header) return;
  var lastY = window.scrollY;
  var threshold = 200;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      // Always show near top
      if (y < threshold) {
        header.classList.remove('is-hidden');
      } else if (y > lastY + 8) {
        // Scrolling down past threshold → hide (only if mobile menu isn't open)
        if (!(menu && menu.classList.contains('is-open'))) {
          header.classList.add('is-hidden');
        }
      } else if (y < lastY - 4) {
        header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curious-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var overlay = document.querySelector('[data-crm-overlay]');
  if (!overlay) return;
  var form = overlay.querySelector('form.crm-form');
  var formBody = overlay.querySelector('[data-crm-form-body]');
  var success = overlay.querySelector('[data-crm-success]');
  var textarea = overlay.querySelector('[data-crm-textarea]');
  var counter = overlay.querySelector('[data-crm-count]');
  var ratingInput = overlay.querySelector('[data-crm-rating-input]');
  var submit = overlay.querySelector('[data-crm-submit]');
  var errBox = overlay.querySelector('[data-crm-error]');
  var stars = overlay.querySelectorAll('[data-crm-star]');
  var photosInput = overlay.querySelector('[data-crm-photos-input]');
  var photosAdd = overlay.querySelector('[data-crm-photos-add]');
  var photosCount = overlay.querySelector('[data-crm-photos-count]');
  var photosWrap = overlay.querySelector('[data-crm-photos]');
  var currentRating = 0;
  var photoFiles = [];

  function open() {
    overlay.setAttribute('data-open', '1');
    document.body.classList.add('crm-locked');
  }
  function close() {
    overlay.setAttribute('data-open', '0');
    document.body.classList.remove('crm-locked');
  }
  function setRating(n) {
    currentRating = n;
    ratingInput.value = n;
    stars.forEach(function (b) {
      b.setAttribute('data-active', parseInt(b.dataset.crmStar, 10) <= n ? '1' : '0');
    });
    validate();
  }
  function validate() {
    var ok = currentRating > 0 && textarea.value.trim().length > 0 && form.querySelector('input[name="contact[name]"]').value.trim().length > 0;
    submit.disabled = !ok;
  }
  function renderPhotos() {
    photosWrap.querySelectorAll('.crm-photo').forEach(function (n) { n.remove(); });
    photoFiles.forEach(function (file, idx) {
      var url = URL.createObjectURL(file);
      var wrap = document.createElement('div');
      wrap.className = 'crm-photo';
      wrap.innerHTML = '<img alt=""><button type="button" class="crm-photo__remove" aria-label="Remove photo">x</button>';
      wrap.querySelector('img').src = url;
      wrap.querySelector('.crm-photo__remove').addEventListener('click', function () {
        photoFiles.splice(idx, 1);
        syncFileInput();
        renderPhotos();
      });
      photosWrap.insertBefore(wrap, photosAdd);
    });
    photosCount.textContent = photoFiles.length + '/5';
    photosAdd.disabled = photoFiles.length >= 5;
  }
  function syncFileInput() {
    var dt = new DataTransfer();
    photoFiles.forEach(function (f) { dt.items.add(f); });
    photosInput.files = dt.files;
  }

  document.querySelectorAll('[data-crm-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  overlay.querySelectorAll('[data-crm-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('data-open') === '1') close();
  });

  stars.forEach(function (btn) {
    btn.addEventListener('click', function () { setRating(parseInt(btn.dataset.crmStar, 10)); });
  });

  textarea.addEventListener('input', function () {
    counter.textContent = textarea.value.length + '/2000';
    validate();
  });
  form.querySelector('input[name="contact[name]"]').addEventListener('input', validate);

  photosAdd.addEventListener('click', function () { photosInput.click(); });
  photosInput.addEventListener('change', function () {
    var incoming = Array.from(photosInput.files || []);
    incoming.forEach(function (f) {
      if (photoFiles.length < 5 && f.type.indexOf('image/') === 0) photoFiles.push(f);
    });
    syncFileInput();
    renderPhotos();
  });

  // Native submission: Shopify auto-injects captcha and emails the shop owner.
  // After submit, Shopify reloads the page with form.posted_successfully? → window.__crmJustPosted.
  form.addEventListener('submit', function () {
    if (submit.disabled) return;
    submit.textContent = 'Sending…';
    submit.disabled = true;
  });

  // If the page was just reloaded after a successful submission, open in success state.
  if (window.__crmJustPosted) {
    open();
    formBody.style.display = 'none';
    success.setAttribute('data-show', '1');
    // Strip Shopify's anchor so refreshes don't re-show it
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curious-related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-curious-rel-viewport]').forEach(function (vp) {
    var scroll = vp.querySelector('[data-curious-rel-scroll]');
    var prev = vp.querySelector('[data-curious-rel-prev]');
    var next = vp.querySelector('[data-curious-rel-next]');
    if (!scroll) return;

    function sync() {
      var overflows = scroll.scrollWidth > scroll.clientWidth + 4;
      vp.setAttribute('data-curious-rel-overflow', overflows ? '1' : '0');
    }

    function maxScroll() { return scroll.scrollWidth - scroll.clientWidth; }

    function step(dir) {
      var card = scroll.querySelector('.curious-rel__card');
      var by = card ? (card.offsetWidth + 20) * Math.max(1, Math.floor(scroll.clientWidth / (card.offsetWidth + 20))) : scroll.clientWidth * 0.8;
      var max = maxScroll();
      var cur = scroll.scrollLeft;
      if (dir > 0 && cur >= max - 2) {
        scroll.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && cur <= 2) {
        scroll.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        scroll.scrollBy({ left: dir * by, behavior: 'smooth' });
      }
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    scroll.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Defer once so images can influence layout width
    sync();
    setTimeout(sync, 200);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
